<template>
  <div class="commercial-guide">
    <div class="deck deck--pull-up" id="appCommercialGuide"> <!-- ID needed for scrollIntoView() -->
      <div class="w--normal">

        <router-view/>

      </div>
    </div>
  </div>
</template>

<script>
// import all Services
import Services from '@/services/Services'
import t from './mixins/t.js'
import SiteNotification from '@/components/common/SiteNotification'
import Icon from '@/components/common/Icon'

export default {
  name: 'App',
  data () {
    return {
      store: {
        error: null,
        loading: true,
        progressing: false,
        redirecting: false,
        cvr: null,
        guidePage: null, // Default guidePage for development
        company: null,
        noCompanyFound: false,
        questions: null,
        resources: require('@/entities/resources.json'),
        config: null
      }
    }
  },
  mixins: [t],
  components: {
    Icon,
    SiteNotification
  },
  created () {
    this.setupBusEvents()
    this.fetchUrlParams()
    this.$bus.$emit('app_getQuestions')
  },
  updated () {},
  mounted () {},
  methods: {
    setupBusEvents () {
      // Setup Global Events
      this.$bus.$on('app_getQuestions', (cvr, guidePage) => {
        this.getQuestions(cvr, guidePage)
      })
      this.$bus.$on('app_getInsurances', (cvr, guidePage) => {
        this.getInsurances(cvr, guidePage)
      })
      this.$bus.$on('app_getContact', (cvr, guidePage) => {
        this.getContact(cvr, guidePage)
      })
      this.$bus.$on('app_submitForm', (cvr, guidePage) => {
        this.postForm(cvr, guidePage)
      })
      this.$bus.$on('app_getInsuranceContact', (cvr, guidePage) => {
        this.getInsurancesContact(cvr, guidePage)
      })
    },
    fetchUrlParams () {
      // Fetch URL params
      const params = new URLSearchParams(window.location.search)
      // CVR
      const cvr = params.get('cvr')
      if (cvr) {
        this.store.cvr = cvr
      }
      // guidePage
      const guidePage = params.get('$guidePage')
      if (guidePage) {
        this.store.guidePage = guidePage
      }
    },
    // Questions
    getQuestions (cvr = this.store.cvr, guidePage = this.store.guidePage) {
      if (cvr) {
        this.getQuestionsByCvr(cvr, guidePage)
      } else {
        this.getQuestionsDefault(guidePage)
      }
    },
    handleRedirect (redirect) {
      // Handle redirect
      if (redirect) {
        this.store.redirecting = true
        this.$nextTick(() => {
          window.location.assign(redirect)
        })
      }
    },
    getQuestionsByCvr (cvr, guidePage) {
      this.store.loading = true
      this.store.error = null
      this.store.noCompanyFound = false

      Services.getQuestionsByCvr(cvr, guidePage)
        .then(response => {
          this.store.loading = false

          if (typeof response.data === 'string') {
            throw TypeError('Fejl i svar fra serveren. Forventede et Object, men fik en String')
          }

          this.handleRedirect(response.data.redirect)

          // Transform Questions
          if (response.data.questions) {
            response.data.questions.map(question => {
              if ((question.type !== 'radios') || (question.type !== 'checkboxes')) {
                if (!question.value) {
                  question.value = ''
                }
              }
              if (question.options) {
                question.options.map(option => {
                  option.checked = false
                })
              }
            })
            // Set Questions
            this.$set(this.store, 'questions', response.data.questions)
          }
          // Set Company
          if (response.data.company) {
            this.$set(this.store, 'company', response.data.company)
          }
          // Resources
          if (response.data.resources) {
            this.$set(this.store, 'resources', response.data.resources)
          }
          // Set Config
          if (response.data.config) {
            this.$set(this.store, 'config', response.data.config)
          }
        })
        .catch(error => {
          this.store.loading = false
          this.store.error = error
          this.store.noCompanyFound = true
        })
    },
    getQuestionsDefault (guidePage) {
      this.store.loading = true
      this.store.error = null
      this.store.noCompanyFound = false

      Services.getQuestionsDefault(guidePage)
        .then(response => {
          this.store.loading = false
          if (typeof response.data === 'string') {
            throw TypeError('Fejl i svar fra serveren. Forventede et Object, men fik en String')
          }

          this.handleRedirect(response.data.redirect)

          // Resources
          if (response.data.resources) {
            this.$set(this.store, 'resources', response.data.resources)
          }
          // Questions
          if (response.data.questions) {
            this.$set(this.store, 'questions', response.data.questions)
          }
        })
        .catch(error => {
          this.store.loading = false
          this.store.error = error
          this.store.noCompanyFound = true
        })
    },
    /* Insurances */
    getInsurances (cvr = this.store.cvr, guidePage = this.store.guidePage) {
      this.store.loading = true
      this.store.error = null

      let data = this.transformQuestions(this.store.questions)

      Services.getInsurances(cvr, guidePage, data)
        .then(response => {
          this.store.loading = false
          // Transform Response (Add 'selected', 'open', etc)
          response.data.insurances.forEach(insurance => {
            if (this.store.insuranceQues) {
              insurance.selected = false
            } else {
              insurance.selected = true
            }
            insurance.open = false
            if (insurance.subInsurances) {
              insurance.subInsurances.forEach(subInsurance => {
                if (this.store.insuranceQues) {
                  subInsurance.selected = false
                }
                subInsurance.open = false
                insurance.id = insurance.id ? insurance.id + ',' + subInsurance.id : subInsurance.id
              })
            }
          })
          response.data.optionalInsurances.forEach(insurance => {
            insurance.selected = false
            insurance.open = false
            if (insurance.subInsurances) {
              insurance.subInsurances.forEach(subInsurance => {
                if (this.store.insuranceQues) {
                  subInsurance.selected = false
                }
                subInsurance.open = false
                insurance.id = insurance.id ? insurance.id + ',' + subInsurance.id : subInsurance.id
              })
            }
          })
          // Set response
          this.$set(this.store, 'insurances', response.data.insurances)
          this.$set(this.store, 'optionalInsurances', response.data.optionalInsurances)
          this.$set(this.store, 'otherInsurances', this.store.otherInsurances)
          this.$set(this.store, 'buttons', response.data.buttons)
          this.$set(this.store, 'progressing', true)
          // Route
          // this.$router.push({ name: 'Insurances', params: { cvr: this.store.cvr } })
        })
        .catch(error => {
          this.store.loading = false
          this.store.error.message = 'error' + error
        })
    },
    /* Contact Info */
    getContact (cvr = this.store.cvr, guidePage = this.store.guidePage) {
      this.store.loading = true
      this.store.error = null

      Services.getContact(cvr, guidePage)
        .then(response => {
          this.store.loading = false
          // Transform Response (Add 'value')
          response.data.form.fields.forEach(field => {
            if (!field.value) {
              if (field.type === 'checkbox' || field.type === 'radio') {
                field.value = false
              } else { // type = 'text'
                field.value = ''
              }
            }
          })
          // Set Contact Info
          this.$set(this.store, 'contact', response.data)
          // Route
          if (this.store.config.insuranceLayout == null) {
            this.$router.push({ name: 'ContactInfo' })
          }
        })
        .catch(error => {
          this.store.loading = false
          this.store.error = error
        })
    },
    /*  insuranceContact */
    getInsurancesContact (cvr = this.store.cvr, guidePage = this.store.guidePage) {
      this.getInsurances(cvr, guidePage)
      this.getContact(cvr, guidePage)
    },
    /* Submit form data */
    postForm (cvr = this.store.cvr, guidePage = this.store.guidePage) {
      this.store.loading = true
      this.store.error = null

      // Post data for Insurance Request
      let data = this.transformPostForm(
        this.store.questions,
        this.store.insurances,
        this.store.optionalInsurances,
        this.store.contact,
        this.store.insuranceContact)

      // Request form data
      Services.postForm(cvr, guidePage, data)
        .then(response => {
          this.store.loading = false
          this.handleRedirect(response.data.redirect)
        })
        .catch(error => {
          this.store.loading = false
          this.store.error = error
        })
    },
    /* Transforms */
    transformQuestions (questions) {
      let data = questions.map(question => {
        let obj
        if (question.type === 'radios') {
          let checkIns = 0
          let returnIns = []
          let arrayValues = ''
          let returnInsValues = []
          let inputValues = ''
          let labelChecked = ''
          let returnInsCheckedValues = []
          // Green button code added for passing insurances of subquestion starts
          if (question.expandOptions !== undefined) {
            for (checkIns = 0; checkIns < question.expandOptions.length; checkIns++) {
              if (question.expandOptions[checkIns].showBox !== undefined) {
                question.expandOptions[checkIns].showBox.forEach(element => {
                  if (element.checked === true) {
                    if (question.expandOptions[checkIns].showBoxValue !== undefined) {
                      question.expandOptions[checkIns].showBoxValue.forEach(subElement => {
                        if (element.id === subElement.id) {
                          arrayValues = element.insurance
                          if (subElement.value === undefined) {
                            inputValues = element.label + ' ' + element.value
                          } else {
                            inputValues = element.label + ' ' + element.value + '  ' + subElement.label + ' ' + subElement.value
                          }
                          returnInsValues.push(inputValues)
                          returnIns.push(arrayValues)
                        }
                      })
                    } else {
                      arrayValues = element.insurance
                      inputValues = element.label + ' ' + element.value
                      returnInsValues.push(inputValues)
                      returnIns.push(arrayValues)
                    }
                  }
                })
                if (returnIns.length === 0) {
                  obj = {
                    id: question.id,
                    input: returnInsValues,
                    value: ''
                  }
                } else {
                  obj = {
                    id: question.id,
                    input: returnInsValues,
                    value: returnIns
                  }
                }
              } else if (question.expandOptions[checkIns].options !== undefined) {
                let checkedOption = question.expandOptions[checkIns].options.find(option => {
                  return option.checked
                })
                if (checkedOption !== undefined) {
                  var insuranceName = checkedOption.value
                  labelChecked = checkedOption.label
                  var returnInsurance = insuranceName.trim()
                  returnInsCheckedValues.push(labelChecked)
                  returnIns.push(returnInsurance)
                  obj = {
                    id: question.id,
                    inputlabel: returnInsCheckedValues[0],
                    value: returnIns
                  }
                } else if (checkedOption === undefined) {
                  obj = {
                    id: question.id,
                    inputlabel: returnInsCheckedValues[0],
                    value: ''
                  }
                }
              } else {
                let checkedOption = question.options.find(option => {
                  return option.checked
                })
                obj = {
                  id: question.id,
                  value: checkedOption.value
                }
              }
            }
          } else {
            let checkedOption = question.options.find(option => {
              return option.checked
            })
            obj = {
              id: question.id,
              value: checkedOption.value
            }
          }
        } else if (question.type === 'checkboxes') {
          let checkedOptions = question.options.filter(option => { return option.checked })
          let arrayValues = checkedOptions.map(option => { return option.value })
          obj = {
            id: question.id,
            value: arrayValues
          }
        } else { // Text, number, tel, email, etc.
          obj = {
            id: question.id,
            value: question.value
          }
        }
        return obj
      })
      return data
    },
    transformInsurances (insurances, value) {
      let chosenInsurances = insurances.filter(insurance => {
        return insurance.selected === value
      })
      let values = chosenInsurances.map(insurance => {
        if (insurance.subInsurances && this.store.insuranceQues) {
          let subInsurances = insurance.subInsurances.filter(subInsurance => { return subInsurance.selected === value })
          let selectedSubInsurances = []
          selectedSubInsurances.push(insurance.title)
          for (let i = 0; i < subInsurances.length; i++) {
            selectedSubInsurances.push(subInsurances[i].id)
          }
          return selectedSubInsurances.toString()
        } else if (insurance.subInsurances && !this.store.insuranceQues) {
          let subInsurances = insurance.subInsurances
          let selectedSubInsurances = []
          selectedSubInsurances.push(insurance.title)
          for (let i = 0; i < subInsurances.length; i++) {
            selectedSubInsurances.push(subInsurances[i].id)
          }
          return selectedSubInsurances.toString()
        } else {
          return insurance.id
        }
      })
      return values
    },
    transformContact (contacts) {
      let data = contacts.form.fields.map(field => {
        if (field.type === 'radio') {
          return {
            id: field.id,
            value: field.value
          }
        } else {
          return {
            id: field.name,
            value: field.value
          }
        }
      })
      return data
    },
    transformPostForm (questions, insurances, optionalInsurances, contacts, otherInsurances) {
      return {
        questions: this.transformQuestions(questions),
        selectedInsurances: this.transformInsurances([...insurances, ...optionalInsurances], true),
        deselectedInsurances: this.transformInsurances([...insurances, ...optionalInsurances], false),
        otherInsurances: this.store.otherInsurances,
        contact: this.transformContact(contacts)
      }
    }
  }
}
</script>

<style lang="scss">
/* Label - Accessibility */
.form__field--checkbox .form__item:focus ~ .form__label .form__label-text {
  text-decoration: underline;
  text-decoration-color:#dc0000;
}
/* Link - Accessibility */
.link:hover span,
.link:focus span {
    color: #dc0000;
}
.link:hover span:after,
.link:focus span:after {
    left: 100%;
}
/* Button - Accesibility */
.button:focus:before,
.button.button--active:before {
    width: 100%;
}
.button:focus,
.button:focus span,
.button:focus .svg-icon,
.button.button--active,
.button.button--active span,
.button.button--active .svg-icon {
    color: #fff;
}

/* Fix size of button together with input fields. */
.singleline-form .form-submit.button--primary {
  padding: 1.0rem 1.625rem;
}

  /* Label with headline */
.form__label--with-headline:before,
.form__label--with-headline:after {
  margin-top:2px;
}

/* Link in form notice */
.form__notice .link {
  display: inline;
}

/* Color - Missing */
.c--grey-7 {
  background:#fbfbfb;
}

/* Text */
.text--center {
  text-align:center;
}
.text--uppercase {
  text-transform: uppercase;
}

/* Development hack */
.env_development {
  padding-top:100px;
  padding-bottom:400px;
}

// From Bootstrap 4
//
// Spacing
//
// Control the default styling of most Bootstrap elements by modifying these
// variables. Mostly focused on spacing.
// You can add more entries to the $spacers map, should you need more variation.

$spacer:   1rem !default;
$spacer-x: $spacer !default;
$spacer-y: $spacer !default;
$spacers: (
  0: (
    x: 0,
    y: 0
  ),
  1: (
    x: $spacer-x,
    y: $spacer-y
  ),
  2: (
    x: ($spacer-x * 1.5),
    y: ($spacer-y * 1.5)
  ),
  3: (
    x: ($spacer-x * 3),
    y: ($spacer-y * 3)
  ),
  4: (
    x: ($spacer-x * 4.5),
    y: ($spacer-y * 4.5)
  )

) !default;
$border-width: 1px !default;

// Width

.w-100 { width: 100% !important; }

// Margin and Padding

.mx-auto {
  margin-right: auto !important;
  margin-left:  auto !important;
}

@each $prop, $abbrev in (margin: m, padding: p) {
  @each $size, $lengths in $spacers {
    $length-x:   map-get($lengths, x);
    $length-y:   map-get($lengths, y);

    .#{$abbrev}a-#{$size} { #{$prop}:        $length-y $length-x !important; } // a = All sides
    .#{$abbrev}t-#{$size} { #{$prop}-top:    $length-y !important; }
    .#{$abbrev}r-#{$size} { #{$prop}-right:  $length-x !important; }
    .#{$abbrev}b-#{$size} { #{$prop}-bottom: $length-y !important; }
    .#{$abbrev}l-#{$size} { #{$prop}-left:   $length-x !important; }

    // Axes
    .#{$abbrev}x-#{$size} {
      #{$prop}-right:  $length-x !important;
      #{$prop}-left:   $length-x !important;
    }
    .#{$abbrev}y-#{$size} {
      #{$prop}-top:    $length-y !important;
      #{$prop}-bottom: $length-y !important;
    }
  }
}

/* Borderline */
@mixin borderline() {
  content: '';
  display: inline-block;
  position: absolute;
  transition: 0.4s cubic-bezier(1, 0, 0, 1);
  transition-property: top, right, bottom, left;
  z-index: 2
}
@mixin borderlineBottom() {
  height: 0.25rem;
  bottom: 0;
  left: 0;
  right: 100%;
}
@mixin borderlineLeft() {
  width: 0.25rem;
  left: 0;
  top: 0;
  bottom: 100%;
}

.borderline {
  position:relative;
  &--lane:before {
    @include borderline();
    background-color: #eee;
  }
  &--lane#{&}--left:before {
    @include borderlineLeft();
  }
  &--lane#{&}--bottom:before {
    @include borderlineBottom();
  }
  &:after {
    @include borderline();
    background-color: #dc0000;
  }
  &--left:after {
    @include borderlineLeft();
  }
  &--left#{&}--lane:before,
  &--left#{&}--hover:hover:after,
  &--left#{&}--active:after {
    bottom:0;
  }
  &--bottom:after {
    @include borderlineBottom();
  }
  &--bottom#{&}--lane:before,
  &--bottom#{&}--hover:hover:after,
  &--bottom#{&}--active:after {
    right:0;
  }
}

.spinner--inline-block {
  display:inline-block;
  vertical-align:middle;
}

@media only screen and (max-width: 768px) {
  /* hide only for mobile */
  .mobile-hide {
    display: none;
  }
  /* Make the padding smaller for mobile view */
  .deck.py-3.px-4 {
    padding: 1.5rem!important;
  }
  /* Make headline more readable */
  .hero.full .hero__content .hero__content__headline {
    padding-top: 1rem;
    margin-bottom: 0.5rem;
  }
  h1 {
    font: 300 1.788rem/1.1 "27Sans", Helvetica, Arial, sans-serif;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue